import * as React from "react";
import { Search } from "lucide-react";
import { cn } from "../lib/utils.js";
import { Input, type InputProps } from "./input.js";

export type SearchInputProps = InputProps & {
  /** Class for the relative wrapper — e.g. "flex-1" to grow inside a toolbar. */
  containerClassName?: string;
};

/**
 * Standard search field: a leading magnifier icon over an {@link Input}. Shared
 * by the dealership sidebar, the contacts toolbar, and the outreach board so
 * every search box looks and behaves identically.
 */
const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, containerClassName, ...props }, ref) => {
    return (
      <div className={cn("relative", containerClassName)}>
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input ref={ref} className={cn("pl-8", className)} {...props} />
      </div>
    );
  },
);
SearchInput.displayName = "SearchInput";

export { SearchInput };
